
























































import {Vue, Component, Prop} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {Navigation} from '@/types';

@Component({
  name: 'NavFooter',
  computed: {
  ...mapGetters('user', ['logged']),
  ...mapGetters(['navigation', 'translations']),
  },
})
export default class NavFooter extends Vue {
  @Prop({default: () => [], type: Array}) public list;
  @Prop({default: () => [], type: Array}) public row;
  @Prop({default: '', type: String}) public loginText;
  @Prop({default: '', type: String}) public newsText;
  @Prop({default: '', type: String}) public businessText;
  @Prop({default: '', type: String}) public profileText;

  public resolvePermission(link) {
    return link?.meta?.hasPermission ?? true;
  }

  public findNav(name: string) {
    return this.navigation.find((route) => {
      return route.name === name;
    });
  }

  public resolveRoutePermission(name) {
    const route = this.findNav(name);
    return route?.meta?.hasPermission ?? true;
  }
}
